var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequiredForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.148682,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F0F2F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.04523V8.25213L8.51536 8.05903L10.0171 9.99006L8.16041 11.1487L6.98635 8.83144L5.81229 11.1487L3.98294 9.99006L5.45734 8.05903L3 8.25213V6.04523L5.45734 6.26592L3.98294 4.3073L5.81229 3.14868L6.98635 5.46592L8.16041 3.14868L10.0171 4.3073L8.51536 6.26592L11 6.04523Z",
    fill: "#F50A05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequiredForm);
export default __webpack_public_path__ + "static/media/required-form.9c5b75f6b50833a238657068f2daced6.svg";
export { ForwardRef as ReactComponent };